import Vue from 'vue';
import App from './App';
import router from './router';
import api from './http';
import i18n from './i18n';
import store from './store';
import global from '@/utils/global';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.min.css';

import mock from "@/mock/index";



Array.prototype.indexOf = function (val) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] == val) return i;
  }
  return -1;
};
Array.prototype.remove = function (val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};


Vue.use(ElementUI);  // 注册使用Element
Vue.use(api);  // 注册使用API模块

Vue.prototype.global = global; // 挂载全局配置模块

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
});


// WEBPACK FOOTER //
// ./src/main.js